import React from "react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import lightTheme from "./lightTheme";
import { CssBaseline } from "@mui/material";
import darkTheme from "./darkTheme";
import { DARK } from "../enums/themeEnums";
import useStore from "../store/useStore";
import { Toaster } from "react-hot-toast";

const MuiThemeProvider = ({ children }) => {
  const { themeMode, accentColor } = useStore();

  const baseTheme = themeMode === DARK ? darkTheme : lightTheme;
  
  const theme = React.useMemo(() => {
    if (!accentColor) return baseTheme;
    
    return createTheme(baseTheme, {
      palette: {
        primary: {
          main: accentColor,
          contrastText: '#fff',
        },
      },
      components: {
        MuiCssBaseline: {
          styleOverrides: (theme) => ({
            ...baseTheme.components.MuiCssBaseline.styleOverrides(theme),
            '::selection': {
              backgroundColor: accentColor,
              color: themeMode === DARK ? '#000' : '#fff',
            },
            '::-moz-selection': {
              backgroundColor: accentColor,
              color: themeMode === DARK ? '#000' : '#fff',
            },
          }),
        },
      },
    });
  }, [baseTheme, accentColor, themeMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          style: {
            fontSize: '12px',
            borderRadius: (theme) => `${theme.shape.borderRadius}px`,
            background: theme.palette.background.paper,
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.divider}`,
            padding: '12px 24px',
            boxShadow: theme.palette.mode === DARK 
              ? '0 8px 32px rgba(0,0,0,0.5)' 
              : '0 8px 32px rgba(74, 63, 53, 0.08)',
          },
          success: {
            iconTheme: {
              primary: theme.palette.primary.main,
              secondary: theme.palette.background.paper,
            },
          },
        }}
      />
      {children}
    </ThemeProvider>
  );
};

export default MuiThemeProvider;